import { FC } from 'react';
// component
import SyrupBaseIngredientsComponent from 'components/main/SyrupBaseIngredients';

const SyrupBaseIngredients: FC = () => {
  return <SyrupBaseIngredientsComponent />;
};

export default SyrupBaseIngredients;
